import { Injectable, inject, signal } from '@angular/core';
import { AnalyticsService } from '@athena/util-monitoring';
import { FeedNotification } from './notification-feed.model';

@Injectable({ providedIn: 'root' })
export class NotificationFeedAnalyticsService {
  readonly #analytics = inject(AnalyticsService);

  // Guard so unread-count-shown only fires once per app lifetime, not on
  // every nav change that re-mounts the bell.
  readonly #unreadCountFired = signal(false);

  feedViewed(count: number): void {
    this.#analytics.trackEvent('notification::feed::viewed', { count });
  }

  notificationOpened(notification: FeedNotification, position: number): void {
    const payload: Record<string, unknown> = {
      type: notification.type,
      position,
    };
    if (notification.type === 'strong-match') {
      payload['pet_id'] = notification.payload.petId;
      payload['score'] = notification.payload.score;
    } else if (notification.type === 'strong-match-summary') {
      payload['extra_count'] = notification.payload.extraCount;
    }
    this.#analytics.trackEvent('notification::feed::opened', payload);
  }

  unreadCountShown(count: number): void {
    if (this.#unreadCountFired()) return;
    if (count <= 0) return;
    this.#unreadCountFired.set(true);
    this.#analytics.trackEvent('notification::feed::unreadCountShown', { count });
  }
}
